import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Home from './pages/home/Home';
import Members from './pages/members/Members';
import Gallery from './pages/gallery/Gallery';
import Events from './pages/events/Events';
import Links from './pages/links/Links';
import Contact from './pages/contact/Contact';

import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/members" element={<Members />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/events" element={<Events />} />
        <Route path="/links" element={<Links />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
